<template>
  <div class="configurations-pdf-configure">
    <b-container fluid>
      <b-container>
        <appPdfConfiguration></appPdfConfiguration>
      </b-container>
      <router-view />
    </b-container>
  </div>
</template>

<script>
import appConfigurationsNav from "@/components/snippets/ConfigurationsNav";

export default {
  components: {
    appConfigurationsNav,
    appPdfConfiguration: () =>
      import("@/components/configurations/pdf-configuration/PdfConfiguration.vue"),
  },
};
</script>
